import { gql } from "apollo-boost"

export default gql`
  query GetMyCourses {
    myStudentCourses {
      id
      status
      tag
      dateCompleted
      course {
        id
        title
        courseType
        hours
        legalHours
        nonlegalHours
        fairhousingHours
        commission
        lessons {
          id
          order
        }
      }
      activeLesson {
        id
      }
    }
  }
`
